import React from 'react';
import './StarsBackground.css';

const StarsBackground = () => {
  // Генерируем случайные звёзды
  const stars = Array.from({ length: 60 }, (_, i) => ({
    id: i,
    size: Math.random() * 2.5 + 1, // Размер от 1px до 3.5px
    left: Math.random() * 100, // Позиция по X от 0% до 100%
    top: Math.random() * 100, // Позиция по Y от 0% до 100%
    animationDuration: Math.random() * 25 + 15, // Длительность от 15s до 40s
    animationDelay: Math.random() * 8, // Задержка от 0s до 8s
    opacity: Math.random() * 0.5 + 0.2, // Непрозрачность от 0.2 до 0.7
  }));

  return (
    <div className="stars-background">
      {stars.map((star) => (
        <div
          key={star.id}
          className="star"
          style={{
            left: `${star.left}%`,
            top: `${star.top}%`,
            width: `${star.size}px`,
            height: `${star.size}px`,
            animationDuration: `${star.animationDuration}s`,
            animationDelay: `${star.animationDelay}s`,
            opacity: star.opacity,
          }}
        />
      ))}
    </div>
  );
};

export default StarsBackground;

